import { render, staticRenderFns } from "./ReceiptCreate.vue?vue&type=template&id=aa39b016"
import script from "./ReceiptCreate.vue?vue&type=script&lang=js"
export * from "./ReceiptCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports